import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  FeatureApiClientBase,
  ApiGetResponse,
} from '@ms/angular-workspace/dist/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ILookups } from '../models';

@Injectable({
  providedIn: 'root',
})
export class LookupsService extends FeatureApiClientBase<any> {
  constructor(private httpClient: HttpClient) {
    super(httpClient, 'lookups');
  }

  load(): Observable<ILookups> {
    return this.httpClient
      .get<ApiGetResponse<ILookups>>(this.url())
      .pipe(map((response) => response.data));
  }
}
